import { Globe2, Link2 } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/overlays";
import { Input } from "@/components/ui/primitives";
import { useWebIngest } from "@/hooks/use-web-ingest";

export function WebsiteDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const ingest = useWebIngest();
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) setUrl("");
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent title="Add a website to the atlas" className="w-[min(620px,92vw)]">
        <form
          className="space-y-4"
          onSubmit={async (event) => {
            event.preventDefault();
            setBusy(true);
            const added = await ingest(url);
            setBusy(false);
            if (added) onOpenChange(false);
          }}
        >
          <div className="flex items-start gap-3 rounded-lg border border-border bg-background p-3">
            <Globe2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
            <p className="text-xs leading-relaxed text-muted-foreground">
              GraphMind extracts the page title, author, publication metadata and readable
              article text. The original link stays attached to its graph node.
            </p>
          </div>
          <Input
            autoFocus
            type="url"
            value={url}
            onChange={(event) => setUrl(event.target.value)}
            placeholder="https://example.com/article"
            aria-label="Website URL"
          />
          <div className="flex items-center justify-between gap-3">
            <span className="font-mono text-[10px] text-muted-foreground">
              Public http/https pages only · private network addresses are blocked
            </span>
            <Button type="submit" variant="default" disabled={!url.trim() || busy}>
              <Link2 className="h-3.5 w-3.5" />
              {busy ? "Reading…" : "Add link"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
